'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slate');

var _utils = require('../utils');

var _changes = require('../changes/');
/**
 * User pressed Enter in an editor
 *
 * Enter on an empty block inside a blockquote exit the blockquote.
 */


function onEnter(opts, event, editor, next) {
  var value = editor.value;
  var startBlock = value.startBlock;

  if (!(0, _utils.getCurrentBlockquote)(opts, value)) {
    return next();
  }

  if (startBlock.text.length !== 0) {
    return next();
  } // FIXME - Block is empty, we exit the blockquote


  event.preventDefault();
  return (0, _changes.unwrapBlockquote)(opts, editor);
}

exports.default = onEnter;